function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isEmpty } from 'lodash';
import pluralize from 'pluralize';
import { serializeQueryParams } from '../utils/serializeQueryParams';
import { delKeys } from '../utils/delKeys';
import { buildURL } from '../utils/buildURL';
import _populateRelationship from '../utils/populateRelationship';
pluralize.addIrregularRule('empi_person', 'empi_people');
var JSONAPIAdapter = /*#__PURE__*/function () {
  function JSONAPIAdapter(http, serializer) {
    _classCallCheck(this, JSONAPIAdapter);
    this.http = http;
    this.serializer = serializer;
  }

  // NOTE! parameters 'groupId' and 'context' are possibly due to be deprecated
  return _createClass(JSONAPIAdapter, [{
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(modelName) {
        var _query,
          _ref,
          page,
          include,
          sort,
          groupId,
          context,
          httpConfig,
          customParams,
          filter,
          fetchAllRecords,
          resource,
          url,
          _yield$this$http$get,
          initialResponse,
          totalPages,
          nextPagesRequests,
          index,
          _url,
          response,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _query = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _ref = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, page = _ref.page, include = _ref.include, sort = _ref.sort, groupId = _ref.groupId, context = _ref.context, httpConfig = _ref.httpConfig, customParams = _ref.customParams;
              filter = _objectSpread({}, _query);
              if (!isEmpty(_query.ids)) {
                delete filter.ids;
                filter.id = _query.ids.join(',');
              }
              fetchAllRecords = (page === null || page === void 0 ? void 0 : page.size) === Infinity;
              resource = pluralize(modelName);
              url = buildURL(resource, {
                setMaxPageSize: fetchAllRecords,
                filter: filter,
                context: context,
                sort: sort,
                page: page,
                include: include,
                groupId: groupId,
                customParams: customParams
              });
              _context.next = 9;
              return this.http.get(url, httpConfig);
            case 9:
              _yield$this$http$get = _context.sent;
              initialResponse = _yield$this$http$get.response;
              if (fetchAllRecords) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return", initialResponse);
            case 13:
              totalPages = initialResponse.data.meta.page.total_pages;
              nextPagesRequests = [];
              for (index = 2; index <= totalPages; index++) {
                _url = buildURL(resource, {
                  setMaxPageSize: fetchAllRecords,
                  filter: filter,
                  context: context,
                  sort: sort,
                  page: index,
                  include: include,
                  groupId: groupId,
                  customParams: customParams
                });
                nextPagesRequests.push(this.http.get(_url, httpConfig));
              }
              _context.next = 18;
              return Promise.allSettled(nextPagesRequests);
            case 18:
              response = _context.sent.reduce(function (acc, _ref2) {
                var value = _ref2.value;
                var pageData = value.response.data.data;
                acc.data.data = [].concat(_toConsumableArray(acc.data.data), _toConsumableArray(pageData));
                return acc;
              }, initialResponse);
              return _context.abrupt("return", response);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function query(_x) {
        return _query2.apply(this, arguments);
      }
      return query;
    }()
  }, {
    key: "findRecord",
    value: function () {
      var _findRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(modelName, id) {
        var _ref3,
          include,
          groupId,
          httpConfig,
          customParams,
          params,
          delimiter,
          resource,
          url,
          _yield$this$http$get2,
          response,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref3 = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {}, include = _ref3.include, groupId = _ref3.groupId, httpConfig = _ref3.httpConfig, customParams = _ref3.customParams;
              params = _objectSpread({
                include: include,
                group_id: groupId
              }, customParams);
              params = delKeys(params);
              params = serializeQueryParams(params);
              delimiter = params ? '?' : '';
              resource = pluralize(modelName);
              url = "/".concat(resource, "/").concat(id).concat(delimiter).concat(params);
              _context2.next = 9;
              return this.http.get(url, httpConfig);
            case 9:
              _yield$this$http$get2 = _context2.sent;
              response = _yield$this$http$get2.response;
              return _context2.abrupt("return", response);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function findRecord(_x2, _x3) {
        return _findRecord.apply(this, arguments);
      }
      return findRecord;
    }()
  }, {
    key: "createRecord",
    value: function () {
      var _createRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(modelName, inputProperties) {
        var _ref4,
          groupId,
          resource,
          url,
          payload,
          _yield$this$http$post,
          response,
          _args3 = arguments;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref4 = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {}, groupId = _ref4.groupId;
              resource = pluralize(modelName);
              url = "/".concat(resource);
              payload = this.serializer.serialize(modelName, inputProperties); // This is here only for 'provided_service', that has the group_id at the top of the paylod request
              // This will be removed
              if (groupId) {
                payload.group_id = groupId;
              }
              _context3.next = 7;
              return this.http.post(url, payload);
            case 7:
              _yield$this$http$post = _context3.sent;
              response = _yield$this$http$post.response;
              return _context3.abrupt("return", response);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createRecord(_x4, _x5) {
        return _createRecord.apply(this, arguments);
      }
      return createRecord;
    }() // TODO: Verify if the ID is needed as searate of we can get it from the obj.id
  }, {
    key: "updateRecord",
    value: function () {
      var _updateRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(modelName, id, inputProperties) {
        var _ref5,
          groupId,
          resource,
          url,
          payload,
          _yield$this$http$patc,
          response,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref5 = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {}, groupId = _ref5.groupId;
              resource = pluralize(modelName);
              url = "/".concat(resource, "/").concat(id);
              payload = this.serializer.serialize(modelName, inputProperties); // This is here only for 'provided_service', that has the group_id at the top of the paylod request
              // This will be removed
              if (groupId) {
                payload.group_id = groupId;
              }
              _context4.next = 7;
              return this.http.patch(url, payload);
            case 7:
              _yield$this$http$patc = _context4.sent;
              response = _yield$this$http$patc.response;
              return _context4.abrupt("return", response);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateRecord(_x6, _x7, _x8) {
        return _updateRecord.apply(this, arguments);
      }
      return updateRecord;
    }()
  }, {
    key: "deleteRecord",
    value: function () {
      var _deleteRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(modelName, id) {
        var resource, url, _yield$this$http$dele, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              resource = pluralize(modelName);
              url = "/".concat(resource, "/").concat(id);
              _context5.next = 4;
              return this.http["delete"](url);
            case 4:
              _yield$this$http$dele = _context5.sent;
              response = _yield$this$http$dele.response;
              return _context5.abrupt("return", response);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function deleteRecord(_x9, _x10) {
        return _deleteRecord.apply(this, arguments);
      }
      return deleteRecord;
    }()
  }, {
    key: "findAll",
    value: function () {
      var _findAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(modelName) {
        var _ref6,
          groupId,
          httpConfig,
          customParams,
          params,
          delimiter,
          resource,
          url,
          _yield$this$http$get3,
          response,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _ref6 = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {}, groupId = _ref6.groupId, httpConfig = _ref6.httpConfig, customParams = _ref6.customParams;
              params = _objectSpread({
                group_id: groupId
              }, customParams);
              params = delKeys(params);
              params = serializeQueryParams(params);
              delimiter = params ? '?' : '';
              resource = pluralize(modelName);
              url = "/".concat(resource).concat(delimiter).concat(params);
              _context6.next = 9;
              return this.http.get(url, httpConfig);
            case 9:
              _yield$this$http$get3 = _context6.sent;
              response = _yield$this$http$get3.response;
              return _context6.abrupt("return", response);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function findAll(_x11) {
        return _findAll.apply(this, arguments);
      }
      return findAll;
    }()
  }, {
    key: "setRelationship",
    value: function () {
      var _setRelationship = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(modelName, id) {
        var _ref7,
          relationshipModel,
          value,
          resource,
          relationshipResource,
          url,
          data,
          _yield$this$http$post2,
          response,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _ref7 = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {}, relationshipModel = _ref7.relationshipModel, value = _ref7.value;
              resource = pluralize(modelName);
              relationshipResource = pluralize(relationshipModel);
              url = "/".concat(resource, "/").concat(id, "/relationships/").concat(relationshipResource);
              data = {};
              if (Array.isArray(value)) {
                data = value.map(function (valueId) {
                  return {
                    id: valueId,
                    type: relationshipModel
                  };
                });
              } else if (!isEmpty(value)) {
                data = _objectSpread({}, value);
              }
              _context7.next = 8;
              return this.http.post(url, {
                data: data
              });
            case 8:
              _yield$this$http$post2 = _context7.sent;
              response = _yield$this$http$post2.response;
              return _context7.abrupt("return", response);
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setRelationship(_x12, _x13) {
        return _setRelationship.apply(this, arguments);
      }
      return setRelationship;
    }()
  }, {
    key: "deleteRelationship",
    value: function () {
      var _deleteRelationship = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(modelName, id, relationshipModel, value) {
        var resource, relationshipResource, url, data, _yield$this$http$dele2, response;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              resource = pluralize(modelName);
              relationshipResource = pluralize(relationshipModel);
              url = "/".concat(resource, "/").concat(id, "/relationships/").concat(relationshipResource);
              if (Array.isArray(value)) {
                data = value.map(function (valueId) {
                  return {
                    id: valueId,
                    type: relationshipModel
                  };
                });
              } else {
                data = {
                  id: value,
                  type: relationshipModel
                };
              }
              _context8.next = 6;
              return this.http["delete"](url, {
                data: {
                  data: data
                }
              });
            case 6:
              _yield$this$http$dele2 = _context8.sent;
              response = _yield$this$http$dele2.response;
              return _context8.abrupt("return", response);
            case 9:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function deleteRelationship(_x14, _x15, _x16, _x17) {
        return _deleteRelationship.apply(this, arguments);
      }
      return deleteRelationship;
    }()
  }, {
    key: "updateRecordMultipart",
    value: function () {
      var _updateRecordMultipart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(modelName, id, inputProperties) {
        var resource, url, formData, _yield$this$http$patc2, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              resource = pluralize(modelName);
              url = "/".concat(resource, "/").concat(id);
              formData = new FormData();
              Object.entries(inputProperties).forEach(function (_ref8) {
                var _ref9 = _slicedToArray(_ref8, 2),
                  key = _ref9[0],
                  value = _ref9[1];
                var formKey = "data[attributes][".concat(key, "]");
                if (_typeof(value) === 'object' && value !== null && !(value instanceof Blob)) {
                  formData.append(formKey, JSON.stringify(value));
                } else {
                  formData.append(formKey, value);
                }
              });
              _context9.next = 6;
              return this.http.patch(url, formData, {
                'Content-Type': 'multipart/form-data'
              });
            case 6:
              _yield$this$http$patc2 = _context9.sent;
              response = _yield$this$http$patc2.response;
              return _context9.abrupt("return", response);
            case 9:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function updateRecordMultipart(_x18, _x19, _x20) {
        return _updateRecordMultipart.apply(this, arguments);
      }
      return updateRecordMultipart;
    }()
  }, {
    key: "uploadFile",
    value: function () {
      var _uploadFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(modelName, id, file, fileName) {
        var resource, url, formData, _yield$this$http$post3, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              resource = pluralize(modelName);
              url = "/".concat(resource, "/").concat(id, "/file_uploads");
              formData = new FormData();
              if (file instanceof Blob) {
                // Blob mode
                // If you pass a Blob instead of a File, you need to send fileName
                formData.append('data', file, fileName);
              } else {
                formData.append('data', file);
              }
              _context10.next = 6;
              return this.http.post(url, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              });
            case 6:
              _yield$this$http$post3 = _context10.sent;
              response = _yield$this$http$post3.response;
              return _context10.abrupt("return", response);
            case 9:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function uploadFile(_x21, _x22, _x23, _x24) {
        return _uploadFile.apply(this, arguments);
      }
      return uploadFile;
    }()
  }, {
    key: "deleteFile",
    value: function () {
      var _deleteFile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(modelName, id, fileId) {
        var resource, url, data, _yield$this$http$dele3, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              resource = pluralize(modelName);
              url = "/".concat(resource, "/").concat(id, "/relationships/file_uploads");
              data = [{
                id: fileId,
                type: 'file_upload'
              }];
              _context11.next = 5;
              return this.http["delete"](url, {
                data: {
                  data: data
                }
              });
            case 5:
              _yield$this$http$dele3 = _context11.sent;
              response = _yield$this$http$dele3.response;
              return _context11.abrupt("return", response);
            case 8:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function deleteFile(_x25, _x26, _x27) {
        return _deleteFile.apply(this, arguments);
      }
      return deleteFile;
    }()
  }, {
    key: "populateRelationship",
    value: function () {
      var _populateRelationship2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(relationshipName, modelName, data, options) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", _populateRelationship(relationshipName, modelName, data, _objectSpread({
                adapter: this
              }, options ? options : {})));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function populateRelationship(_x28, _x29, _x30, _x31) {
        return _populateRelationship2.apply(this, arguments);
      }
      return populateRelationship;
    }()
  }]);
}();
export { JSONAPIAdapter as default };
//# sourceMappingURL=JSONAPIAdapter.js.map